import mime from 'mime';
import { PNG } from 'pngjs/browser';
import * as jpeg from 'jpeg-js';

export interface LoadingStrategy {
  load(resourceLocation: string): Promise<Uint8Array>;
}

export interface Loader {}

export class ResourceLoader {
  constructor(private loadingStrategy: LoadingStrategy) {}

  async loadResource(resourceLocation: string): Promise<Uint8Array> {
    return await this.loadingStrategy.load(resourceLocation);
  }

  async loadImageResource(resourceLocation: string): Promise<ImageResource> {
    let data = await this.loadResource(resourceLocation);
    let mimeType = mime.getType(resourceLocation);

    return this.loadImageData(data, mimeType as string);
  }

  async loadImageData(data: Uint8Array, mimeType: string) {
    switch (mimeType) {
      case 'image/png':
        return await this.loadPngImage(data);
      case 'image/jpeg':
      case 'image/jpg':
        return await this.loadJpegImage(data);
      default:
        throw new Error(`${mimeType} is not a supported image mime-type`);
    }
  }

  private loadPngImage(data: Uint8Array): Promise<ImageResource> {
    return new Promise((resolve, reject) => {
      new PNG().parse(data as any, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  private loadJpegImage(data: Uint8Array): Promise<ImageResource> {
    return Promise.resolve(jpeg.decode(data, { useTArray: true }) as ImageResource);
  }
}

type ImageResource = {
  data: Uint8Array;
  width: number;
  height: number;
};
